import React, { useState } from "react";

export const CustomizationContext = React.createContext({
    customizationData: {
        idCustomization: "",
        idUtente: "",
        idBasicModel: 0,
        moodType: "",
        language: "",
        rootImages: ""
    },
    updateCustomizationData: () => { },
});

export const CustomizationContextProvider = (props) => {
    const [customizationData, setCustomizationData] = useState({
        idCustomization: "",
        idUtente: "",
        idBasicModel: 0,
        moodType: "",
        language: "",
        rootImages: ""
    });


    const UpdateCustomizationData = (customizationData) => {
        setCustomizationData(customizationData);
    };

    return (
        <CustomizationContext.Provider value={{
            customizationData: customizationData,
            updateCustomizationData: UpdateCustomizationData,
        }}>
            {props.children}
        </CustomizationContext.Provider>
    );
};

export default CustomizationContext;
